import { ErrorHandler, Injectable } from '@angular/core';

declare var NREUM: any; // Declare New Relic global object

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any) {
    // Report the error to New Relic
    if (NREUM) {
      NREUM.noticeError(error);
      console.error('An error occurred:', error);
    }
  }
}
